var render, staticRenderFns
import script from "./addWelcomePageForm.vue?vue&type=script&lang=js"
export * from "./addWelcomePageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d7a3c",
  null
  
)

export default component.exports